import { Tables } from "@/lib/supabase/supabase_types_override";
import { QuestionWithResponses } from "..";
import { QuestionTypeChangedChange } from "@/features/survey_sync/types/syncCheckResult";

export const checkIfQuestionTypeChanged = (
  question: QuestionWithResponses,
  templateQuestion: Tables<"survey_bank_question_bank">
): QuestionTypeChangedChange | false => {
  if (question.field_type !== templateQuestion.field_type) {
    return {
      type: "QUESTION_TYPE_CHANGED",
      context: {
        instanceFieldType: question.field_type || '',
        templateFieldType: templateQuestion.field_type || '',
      },
    };
  }
  return false;
};